export const attentionListStyle = {
	wrapper: {
		maxWidth: '420px',
		width: '100%',
		padding: '16px 16px 16px 16px',
		borderRadius: '8px',
		background: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},

	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: '4px',
		paddingRight: '10px',
	},

	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
};
